// extracted by mini-css-extract-plugin
export default {"root":"aIWZEyMCrp","root_success":"OkQx5Jf_AC","status":"XKJzuOpKdl","root_error":"Vtoor8cPID","result":"ormzJLesaj","header":"VAvwFCHSJp","divider":"RvVAO4YjFm"};